import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import Notification from "../shared/notification";
import style from "./login.module.css";
import analytics from "../shared/analytics"

import * as actions from "./loginActions";
import * as routes from "../shared/routes";

class Login extends Component {
  constructor(props) {
    super(props);
    analytics.pageView();
    this.state = { username: "", password: "" };
    this.formRef = React.createRef();
    this.props.onLogout();
  }

  componentDidMount() {
    if (this.formRef.current) {
      this.formRef.current.addEventListener("submit", e => this.submitHandler(e));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.error && nextProps.error) {
      Notification.showNotification("danger", nextProps.error);
    }
  }

  usernameChangedHandler = event => {
    this.setState({ username: event.target.value });
  };

  passwordChangedHandler = event => {
    this.setState({ password: event.target.value });
  };

  submitHandler = event => {
    this.props.onLogin(this.state.username, this.state.password);
  };

  render() {
    let redirectURL = null;
    if (this.props.token) {
      return <Redirect to={routes.caseSearch} />;
    }
    let logoUrl = "https://cdn.svc.oneadvanced.com/mosaic/2.0.0/img/logo.svg";
    let logoAlt = "Advanced"
    if (process.env.NODE_ENV === 'production') {
      logoUrl = window.applicationIcon;
      logoAlt = window.applicationName;
    }

    return (

      <React.Fragment>
        {redirectURL}
        <mosaic-page class={style.mosaicpage}>
          <mosaic-content-container>
            <mosaic-main-container fluid>
              <div className={style.pageBgOverlay} />
              <mosaic-card class={style.card}>
                <mosaic-card-body class="pb-0">
                  <div className={style.logo}>
                    <img src={logoUrl}
                      alt={logoAlt}
                    />
                  </div>
                  <h1 className={style.appName}>
                    <span><mosaic-translation Key="app.company.name"></mosaic-translation></span>
                  </h1>
                  <div className="content">
                    <h2 className={style.contentTitle}>
                      Enter your details to log in
                    </h2>

                    <mosaic-form
                      ref={this.formRef}
                      class="form"
                      prevent-default
                    >
                      <mosaic-text-input
                        name="username"
                        block
                        required
                        prepend
                        icon="user"
                        label="Username"
                        placeholder="Enter your username"
                        invalid-text="User name is required"
                        onInput={this.usernameChangedHandler}
                        value={this.state.username}
                      />

                      <mosaic-password-input
                        name="password"
                        block
                        required
                        prepend
                        icon="password"
                        label="Password"
                        placeholder="Enter your password"
                        invalid-text="This is some invalid text"
                        onInput={this.passwordChangedHandler}
                        value={this.state.password}
                      />

                      <mosaic-form-actions>
                        <mosaic-button
                          color="primary"
                          icon="login_rounded_right"
                          class="btn-block"
                          submit
                          block
                        >
                          Log in
                        </mosaic-button>
                      </mosaic-form-actions>
                    </mosaic-form>
                    <NavLink
                      to={routes.recoverPassword}
                      className={style.forgottenPasswordLink}
                    >
                      <small>Forgotten Password?</small>
                    </NavLink>
                  </div>
                </mosaic-card-body>
                <mosaic-card-footer class="p-0">
                  <div className={style.loginFooter}>
                    <small className={style.small}>&copy;2019 Advanced</small>
                  </div>
                </mosaic-card-footer>
              </mosaic-card>
            </mosaic-main-container>
          </mosaic-content-container>
        </mosaic-page>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.login.token,
    loading: state.login.loading,
    error: state.login.error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLogin: (email, password) => dispatch(actions.login(email, password)),
    onLogout: () => dispatch(actions.logout())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
